import { MONTH_DICT, MONTH_NAME_TO_NUM } from '@/consts';

export function formatDateString(isoString: string) {
    const dateObj = new Date(isoString);
    const day = dateObj.getUTCDate().toString().padStart(2, '0');
    const year = dateObj.getFullYear().toString();
    const timeHour = dateObj.getUTCHours().toString().padStart(2, '0');
    const timeMinute = dateObj.getUTCMinutes().toString().padStart(2, '0');
    const timeSecond = dateObj.getUTCSeconds().toString().padStart(2, '0');

    const monthIndex = dateObj.getMonth();
    const month = MONTH_DICT[(monthIndex + 1) as keyof typeof MONTH_DICT];

    return {
        day,
        month,
        year,
        timeHour,
        timeMinute,
        timeSecond,
    };
}

export function getMonthNumberFromName(monthName: string): string {
    const n = MONTH_NAME_TO_NUM[monthName];
    return n !== undefined ? String(n).padStart(2, '0') : '';
}
